<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";

export default {
  name: "SplitterMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin],

  props: {
    /**
     * Fields specific for the selected material
     */
    familySpecificFields: {
      type: Object,
      required: true
    },

    /**
     * Loss value of the material
     */
    lossValue: {},

    editingData: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      /**
       * Possible types of equipments
       * OLT(olt) or Splitter(sp)
       */
      equipmentTypeOptions: null
    };
  },

  /**
   * Executed when the component is mounted
   * It's a preemptive verification
   *
   */
  mounted() {
    this.loadEquipmentTypeOptions();
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("EquipmentType"),
          value: !this.editingData
            ? this.parseSelectValue([this.familySpecificFields.sms_type], this.equipmentTypeOptions)
            : this.familySpecificFields.sms_type,
          varName: 'sms_type',
          inputType: 'select',
          disabled: false,
          required: true,
          options: this.equipmentTypeOptions,
          clearable: true,
          size: '100%'
        },
        {
          label: this.$i18n.tc("InPort", 2),
          value: this.familySpecificFields.sms_in_ports,
          varName: 'sms_in_ports',
          inputType: 'number',
          disabled: false,
          required: true,
          min: '1',
        },
        {
          label: this.$i18n.tc("OutPort", 2),
          value: this.familySpecificFields.sms_out_ports,
          varName: 'sms_out_ports',
          inputType: 'number',
          disabled: false,
          required: true,
          min: '0',
        },
        {
          label: this.$i18n.t("LossValue"),
          value: this.lossValue,
          varName: 'sm_loss_value',
          inputType: 'number',
          disabled: false,
          step: '.00001',
          min: '0',
        },
        {
          label: this.$i18n.t("LossValueInCascade"),
          value: this.familySpecificFields.sms_cascade_loss_value,
          varName: 'sms_cascade_loss_value',
          inputType: 'number',
          disabled: false,
          step: '.00001',
          min: '0',
        },
      ]
    },

    /**
     * Indicates if the in and out ports values are valid
     */
    portsAreValid() {
      if (
        this.familySpecificFields.sms_in_ports &&
        this.familySpecificFields.sms_out_ports
      ) {
        return (
          this.familySpecificFields.sms_out_ports >= 0 &&
          this.familySpecificFields.sms_in_ports >= 1 &&
          this.familySpecificFields.sms_out_ports %
            this.familySpecificFields.sms_in_ports ===
            0
        );
      }
      return true;
    }
  },

  /**
   * Watches for changes in various attributes, once one changes, the method requiredFieldsFilled is executed, to verify the
   * validity of the attributes
   */
  watch: {
    /**
     * When the attribute changes
     */
    "familySpecificFields.sms_type"() {
      this.requiredFieldsFilled();
      if (this.familySpecificFields.sms_type === "sp") {
        this.familySpecificFields.sms_in_ports = 1;
      }
    },

    editingData() {
      this.requiredFieldsFilled();
    },
  },

  methods: {
    /**
     * Loads the equipment type options
     */
    async loadEquipmentTypeOptions() {
      try {
        this.equipmentTypeOptions = await this.getList(
          "list_logical_equipment_type",
          [this.familySpecificFields.sms_type],
          false
        );
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return (
        !!this.familySpecificFields.sms_out_ports &&
        !!this.familySpecificFields.sms_in_ports &&
        this.familySpecificFields.sms_out_ports >= 0 &&
        this.familySpecificFields.sms_in_ports >= 1 &&
        this.familySpecificFields.sms_out_ports %
          this.familySpecificFields.sms_in_ports ===
          0 &&
        !!this.familySpecificFields.sms_type &&
        this.familySpecificFields.sms_type.length > 0
      );
    }
  }
};
</script>

<style scoped>
.invalid {
  border: 1px solid var(--red);
}
</style>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsSplitter.vue